exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background-color:#fff}.search-panel{position:fixed;top:0;padding:30px;left:0;right:0;width:100%;background:#fff;box-shadow:0 0 2px #000;transition:all .2s;transform:translateX(0)}.panel2{visibility:hidden}", ""]);

// exports
